import { defineComponent as _defineComponent } from 'vue'
import { useFormElement } from '../../composables/useFormElement';
import { makeUseFormElementEmits, makeUseFormElementProps } from '../../composables/useFormElementInterfaces';
import { FieldModel } from '../../interfaces';
import { useBaseFieldValues } from '../../composables/useBaseFieldValues';
import RemainingCharCounter from 'ah-common-lib/src/common/components/RemainingCharCounter.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputGroupWrapper',
  props: makeUseFormElementProps<FieldModel, any>(),
  emits: makeUseFormElementEmits<any>(),
  setup(__props, { emit }) {

const props = __props;





const formElement = useFormElement({
  emit,
  props,
});

const { fieldErrorsShown, disabled, readonly, inputErrorClass, maxLength } = useBaseFieldValues(formElement);

const { modelStateRef, model, field, getSlotName } = formElement;

const inputGroupClass = modelStateRef('inputGroupClass', '');

const showLengthCounter = modelStateRef('showLengthCounter', false);

const hideAppendBg = modelStateRef('removeAppendBg', false);

return { __sfc: true,props, emit, formElement, fieldErrorsShown, disabled, readonly, inputErrorClass, maxLength, modelStateRef, model, field, getSlotName, inputGroupClass, showLengthCounter, hideAppendBg, RemainingCharCounter }
}

})